import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-482bbed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-view container d-flex justify-content-center py-4 py-md-5" }
const _hoisted_2 = { class: "col-12 col-lg-11 col-xl-10" }

import { PagedResultOfCustomerOrdersDto } from "@/api-client";
import { useHead } from "@unhead/vue";
import { useUserStore } from "@/stores/user";
import { onBeforeMount, Ref, ref } from "vue";
import { getCustomerOrders } from "@/api/customer";
import Pagination from "@/components/misc/Pagination.vue";
import PageHero from "@/components/misc/PageHero.vue";
import CustomerProducts from "@/components/products/CustomerProducts.vue";
import { useRouter, useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsView',
  setup(__props) {

useHead({
  title: "My Products",
});

const userStore = useUserStore();
const hasLoaded = ref(false);
const router = useRouter();
const route = useRoute();
const data: Ref<PagedResultOfCustomerOrdersDto> = ref({
  totalCount: 0,
  pageCount: 1,
  pageSize: 5,
  pageNumber: 1,
  data: []
});

onBeforeMount(async () => {
  if(route.query.page) {
    data.value.pageNumber = +route.query.page;
  }

  await loadInitialData();
});

async function handlePageChange(page: number) {
  data.value.pageNumber = page;
  await loadInitialData();
}

async function loadInitialData() {
  if (userStore.id) {
    await getCustomerOrders(userStore.id, data.value.pageNumber, data.value.pageSize).then((res) => {
      if(data.value.pageNumber !== 1 && !res.data.length) {
        // Handle page query attempting to access a page number that doesnt have data
        data.value.pageNumber = 1;
        loadInitialData();
      } else {
        data.value = res;
        hasLoaded.value = true;

        if(data.value.pageNumber == 1 || (data.value.pageNumber == 1 && route.query.page)) {
          router.replace({ name: "Products" })
        } else {
          router.replace({ name: "Products", query: { page: data.value.pageNumber } })
        }
      }
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageHero, {
        title: "My Products",
        subtitle: "Your lines, bills and payments. Recharge, change your deal or pause billing from here."
      }),
      _createVNode(CustomerProducts, {
        data: data.value.data,
        hasLoaded: hasLoaded.value,
        onReload: loadInitialData
      }, null, 8, ["data", "hasLoaded"]),
      _createVNode(Pagination, {
        data: data.value,
        onChange: handlePageChange,
        disableScrollTop: true
      }, null, 8, ["data"])
    ])
  ]))
}
}

})